(function () {
  angular.module('binky.core.storage-utils', ['binky.core.feature', 'binky.core.src2-migration']);
})();
